function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import { IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { FirstPage as FirstPageIcon, KeyboardArrowLeft, KeyboardArrowRight, LastPage as LastPageIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import PaginationCss from '../css/PaginationCss';

var TablePaginationActions = function (_Component) {
  _inherits(TablePaginationActions, _Component);

  function TablePaginationActions() {
    var _temp, _this, _ret;

    _classCallCheck(this, TablePaginationActions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleFirstPageButtonClick = function (event) {
      _this.props.onChangePage(event, 0);
    }, _this.handleBackButtonClick = function (event) {
      _this.props.onChangePage(event, _this.props.page - 1);
    }, _this.handleNextButtonClick = function (event) {
      _this.props.onChangePage(event, _this.props.page + 1);
    }, _this.handleLastPageButtonClick = function (event) {
      _this.props.onChangePage(event, Math.max(0, Math.ceil(_this.props.count / _this.props.rowsPerPage) - 1));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  TablePaginationActions.prototype.render = function render() {
    var _props = this.props,
        classes = _props.classes,
        count = _props.count,
        page = _props.page,
        rowsPerPage = _props.rowsPerPage,
        theme = _props.theme;
    return React.createElement('div', {
      className: classes.root
    }, React.createElement(IconButton, {
      onClick: this.handleFirstPageButtonClick,
      disabled: page === 0
    }, theme.direction === 'rtl' ? React.createElement(LastPageIcon, null) : React.createElement(FirstPageIcon, null)), React.createElement(IconButton, {
      onClick: this.handleBackButtonClick,
      disabled: page === 0
    }, theme.direction === 'rtl' ? React.createElement(KeyboardArrowRight, null) : React.createElement(KeyboardArrowLeft, null)), React.createElement(IconButton, {
      onClick: this.handleNextButtonClick,
      disabled: page >= Math.ceil(count / rowsPerPage) - 1
    }, theme.direction === 'rtl' ? React.createElement(KeyboardArrowLeft, null) : React.createElement(KeyboardArrowRight, null)), React.createElement(IconButton, {
      onClick: this.handleLastPageButtonClick,
      disabled: page >= Math.ceil(count / rowsPerPage) - 1
    }, theme.direction === 'rtl' ? React.createElement(FirstPageIcon, null) : React.createElement(LastPageIcon, null)));
  };

  return TablePaginationActions;
}(Component);

TablePaginationActions.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired
} : {};
export default withStyles(PaginationCss, {
  withTheme: true
})(TablePaginationActions);